import { Button } from '@material-ui/core';
import { useHistory } from 'react-router';
import styled from 'styled-components';
import { Routes } from '../../const/Routes';
import { border, colors } from '../../const/Styles';
import { LocationState as LocationStateForPlayingVideoCard } from '../../video/PlayingVideoCard';

const Container = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 12px 60px;
    width: 100%;
    color: ${colors.footerIconSelected};
    border-top: solid 5px ${border.gray};
    gap: 32px;
    box-sizing: border-box;
`;

const BackButton = styled(Button)`
    background-color: ${colors.footerIconSelected};
    color: ${colors.black};
    font-weight: bold;
    padding: 4px;
    font-size: 18px;
    border-radius: 4px;
    min-width: 200px;
    width: 100%;
`;

type Props = {
    prevPagePath: string;
};

const ReturnPerviousButton: React.FC<Props> = ({ prevPagePath }) => {
    const history = useHistory<
        LocationStateForPlayingVideoCard & { from?: string }
    >();

    const backToPrev = () => {
        history.goBack();
    };

    const backToLesson = () => {
        history.replace(Routes.LESSON_START);
    };

    return (
        <Container>
            {prevPagePath === Routes.LESSON_PLAY_SWING && (
                <BackButton onClick={backToPrev}>スイング再生に戻る</BackButton>
            )}
            <BackButton onClick={backToLesson}>レッスン画面に戻る</BackButton>
        </Container>
    );
};

export default ReturnPerviousButton;
